import type { GetDepartmentTypesByNameResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetDepartmentTypesByNameQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetDepartmentTypesByNameDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createLazyQueryHook } from 'src/utils';

type QueryArgs = { Name: string };

export const useLazyGetDepartmentTypesByName = createLazyQueryHook<
  QueryArgs,
  GetDepartmentTypesByNameResponseRow[],
  GetDepartmentTypesByNameQuery
>({
  trpcQuery: (client, args) =>
    client.frontend.department.departmentTypesByName.query({
      name: args.Name,
    }),
  mapTrpcDataToGraphQL: (data) => ({ department_type: data }),
  graphqlDocument: GetDepartmentTypesByNameDocument,
  graphqlVariables: (args) => ({ Name: args.Name }),
});
